import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { CategoryGrid } from './components/CategoryGrid';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { useAppStore } from 'stores/appStore';

export function CategoryContent() {
  const { t } = useTranslation();

  const selectedCategory = useAppStore((state) => state.selectedCategory);

  return (
    <StepLayout
      title={t('category.heading')}
      description={t('category.description')}
      nextButtonProps={{
        label: t('category.cta'),
        disabled: !selectedCategory,
      }}
    >
      <CategoryGrid />
    </StepLayout>
  );
}
